import type {
  ApiChildResults,
  ApiDomainResult,
  ApiDomainResults,
  ChildDevelopment,
  ChildDevelopmentObservation,
  DevelopmentScore,
} from '../types';

const toDevelopmentScore = (result: ApiDomainResult | null, fallbackAge: number): DevelopmentScore => ({
  age: result?.age ?? fallbackAge,
  dScore: result?.dScore ?? 0,
});

export const toChildDevelopment = (results: ApiChildResults): ChildDevelopment => {
  const observations: ChildDevelopmentObservation[] = [];
  for (const questionnaire of results.questionnaires) {
    const domainResults: ApiDomainResults | null = questionnaire.results;
    if (domainResults === null || domainResults.dScore === null || domainResults.dScore.dScore === null) continue;
    const overallAge: number = domainResults.dScore.age;
    observations.push({
      overall: { age: overallAge, dScore: domainResults.dScore.dScore },
      domains: {
        'grove-motoriek': toDevelopmentScore(domainResults.grossMotor, overallAge),
        'fijne-motoriek': toDevelopmentScore(domainResults.fineMotor, overallAge),
        taal: toDevelopmentScore(domainResults.language, overallAge),
        cognitief: toDevelopmentScore(domainResults.cognitive, overallAge),
        'sociaal-emotioneel': toDevelopmentScore(domainResults.social, overallAge),
      },
    });
  }
  return {
    observations: observations.sort(
      (first: ChildDevelopmentObservation, second: ChildDevelopmentObservation): number =>
        first.overall.age - second.overall.age,
    ),
  };
};
